<!-- Mobile-Optimized Carton Scanner -->
<div class="mobile-carton-scanner">

  <!-- PHASE 1: STICKY HEADER WITH SHIPMENT INFO -->
  <div class="scanner-sticky-header" *ngIf="autoDetectedPreAlert || scanProgressRT">
    <div class="header-shipment-badge">
      <i class="bi bi-box-seam me-2"></i>
      {{ (scanProgressRT?.ladingBill || autoDetectedPreAlert?.ladingBill) || 'Scanner Ready' }}
    </div>
    <div class="header-connection-status">
      <span class="status-dot-header"
            [class.status-connected]="isSignalRProgressConnected || signalRConnected"></span>
      {{ (isSignalRProgressConnected || signalRConnected) ? 'Live' : 'Offline' }}
    </div>
  </div>
  <!-- MODERN REAL-TIME PROGRESS CARD (NEW) -->
  <div class="modern-progress-card mb-3" *ngIf="showModernProgressCard && scanProgressRT"
       [@slideIn]="showModernProgressCard">
    <div class="card border-0 shadow-lg" [class.pulse-animation]="progressScanAnimation">
      <div class="card-body p-4">
        <!-- Progress Header with Connection Status -->
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="mb-0 fw-bold">
            <i class="bi bi-broadcast me-2"></i>
            Live Scan Progress
          </h5>
          <div class="connection-badge">
            <span class="badge"
                  [class.bg-success]="isSignalRProgressConnected"
                  [class.bg-secondary]="!isSignalRProgressConnected">
              <span class="status-dot"
                    [class.status-dot-connected]="isSignalRProgressConnected"></span>
              {{ isSignalRProgressConnected ? 'Live' : 'Offline' }}
            </span>
          </div>
        </div>

        <!-- Pre-Alert Info Badge -->
        <div class="mb-3" *ngIf="scanProgressRT.ladingBill">
          <span class="badge bg-info fs-6 px-3 py-2">
            <i class="bi bi-truck me-1"></i>
            {{ scanProgressRT.ladingBill }}
          </span>
        </div>

        <!-- Large Progress Bar with Percentage -->
        <div class="progress-modern mb-3" style="height: 48px; border-radius: 24px;">
          <div class="progress-bar progress-bar-striped progress-bar-animated fw-bold"
               [class]="modernProgressBarClass"
               role="progressbar"
               [style.width.%]="modernProgressPercentage"
               [attr.aria-valuenow]="modernProgressPercentage"
               aria-valuemin="0"
               aria-valuemax="100">
            <span class="fs-4">{{ modernProgressPercentage }}%</span>
          </div>
        </div>

        <!-- Stats Row with Icons -->
        <div class="row g-3 text-center mb-3">
          <div class="col-4">
            <div class="stat-card-modern">
              <i class="bi bi-check-circle-fill text-success fs-1"></i>
              <div class="fw-bold fs-3 mt-2">{{ modernProgressScannedCount }}</div>
              <small class="text-muted text-uppercase">Scanned</small>
            </div>
          </div>
          <div class="col-4">
            <div class="stat-card-modern">
              <i class="bi bi-box-seam text-primary fs-1"></i>
              <div class="fw-bold fs-3 mt-2">{{ modernProgressTotalCount }}</div>
              <small class="text-muted text-uppercase">Total</small>
            </div>
          </div>
          <div class="col-4">
            <div class="stat-card-modern">
              <i class="bi bi-hourglass-split text-warning fs-1"></i>
              <div class="fw-bold fs-3 mt-2">{{ modernProgressRemainingCount }}</div>
              <small class="text-muted text-uppercase">Remaining</small>
            </div>
          </div>
        </div>

        <!-- Completion Badge -->
        <div *ngIf="modernProgressIsComplete" class="alert alert-success border-0 shadow-sm mb-0 text-center">
          <i class="bi bi-check-circle-fill me-2 fs-4"></i>
          <strong class="fs-5">All cartons scanned!</strong>
        </div>

        <!-- Recent Scans Mini List -->
        <div *ngIf="recentProgressScans.length > 0 && !modernProgressIsComplete" class="mt-3">
          <div class="recent-scans-header mb-2">
            <small class="text-muted fw-bold text-uppercase">
              <i class="bi bi-clock-history me-1"></i>
              Recent Activity
            </small>
          </div>
          <div class="recent-scan-item" *ngFor="let scan of recentProgressScansDisplay">
            <div class="d-flex justify-content-between align-items-center py-2 border-bottom">
              <div class="d-flex align-items-center">
                <i class="bi bi-check-circle-fill text-success me-2"></i>
                <span class="fw-semibold">{{ scan.cartonNumber }}</span>
              </div>
              <div class="text-end">
                <small class="text-muted">{{ formatTimestamp(scan.timestamp) }}</small>
                <br>
                <small class="text-muted fst-italic" *ngIf="scan.scannedBy">by {{ scan.scannedBy }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modern Circular Progress Card -->
  <div class="modern-card" *ngIf="config.showProgress" [@fadeIn]>
    <div class="card-gradient-header">
      <h5 class="mb-0 d-flex align-items-center gap-2">
        <i class="bi bi-clipboard-check-fill"></i>
        Scan Progress
      </h5>
    </div>

    <!-- Circular Progress Display -->
    <div class="circular-progress-wrapper">
      <app-circular-progress
        [size]="140"
        [strokeWidth]="12"
        [percentage]="progress.completionPercentage"
        [current]="progress.scannedCount"
        [total]="progress.expectedCount"
        label="Cartons Scanned">
      </app-circular-progress>
    </div>

    <!-- Stats Grid -->
    <div class="stats-grid">
      <div class="stat-item success">
        <i class="bi bi-check-circle-fill"></i>
        <div class="stat-value">{{ progress.matchedCount }}</div>
        <div class="stat-label">Matched</div>
      </div>
      <div class="stat-item warning">
        <i class="bi bi-exclamation-circle-fill"></i>
        <div class="stat-value">{{ progress.unexpectedCount }}</div>
        <div class="stat-label">Extra</div>
      </div>
      <div class="stat-item danger">
        <i class="bi bi-dash-circle-fill"></i>
        <div class="stat-value">{{ progress.shortageCount }}</div>
        <div class="stat-label">Missing</div>
      </div>
    </div>

    <!-- Status Badge -->
    <div class="text-center mt-3">
      <span class="badge fs-6 px-4 py-2"
            [class.bg-success]="progress.isComplete"
            [class.bg-primary]="!progress.isComplete">
        <i class="bi" [class.bi-check-circle-fill]="progress.isComplete" [class.bi-hourglass-split]="!progress.isComplete"></i>
        {{ progress.isComplete ? 'Complete' : 'In Progress' }}
      </span>
    </div>

    <!-- Shortage Alert -->
    <div class="alert alert-warning mt-3 border-0 shadow-sm" *ngIf="hasShortage" [@slideIn]>
      <i class="bi bi-exclamation-triangle-fill me-2"></i>
      <strong>Missing {{ progress.shortageCount }} cartons:</strong>
      <div class="mt-2 d-flex flex-wrap gap-2">
        <span class="badge bg-warning text-dark" *ngFor="let carton of missingCartons">
          {{ carton }}
        </span>
      </div>
    </div>
  </div>

  <!-- Pre-Alert Detection Info Panel -->
  <div class="modern-card" *ngIf="showPreAlertInfo && autoDetectedPreAlert">
    <div class="card-gradient-header">
      <div class="d-flex justify-content-between align-items-center">
        <h6 class="mb-0">
          <i class="fas fa-truck me-2"></i>
          Pre-Alert: {{autoDetectedPreAlert.ladingBill}}
        </h6>
        <button type="button" class="btn btn-sm btn-light" (click)="resetPreAlert()">
          <i class="fas fa-redo"></i> Reset
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <small class="text-muted">Transport Company</small>
        <div>{{autoDetectedPreAlert.transportCompany}}</div>
      </div>
      <div class="col-6">
        <small class="text-muted">Total Cartons</small>
        <div>{{autoDetectedPreAlert.totalCartons}}</div>
      </div>
      <div class="col-6 mt-2">
        <small class="text-muted">From</small>
        <div>{{autoDetectedPreAlert.departureLocation}}</div>
      </div>
      <div class="col-6 mt-2">
        <small class="text-muted">To</small>
        <div>{{autoDetectedPreAlert.arrivalLocation}}</div>
      </div>
    </div>
    <div class="mt-2">
      <span class="badge bg-success" *ngIf="preAlertLocked">
        <i class="fas fa-lock me-1"></i> Locked to this Pre-Alert
      </span>
    </div>
  </div>

  <!-- Auto-Detection Loading State -->
  <div class="alert alert-info py-2" *ngIf="isDetectingPreAlert">
    <div class="spinner-border spinner-border-sm me-2"></div>
    Detecting pre-alert from carton...
  </div>

  <!-- Auto-Detection Success Alert -->
  <div class="alert alert-success" *ngIf="autoDetectedPreAlert && !preAlertLocked">
    <div class="d-flex align-items-center justify-content-between">
      <span>
        <i class="fas fa-info-circle me-2"></i>
        Pre-alert auto-detected. Scan another carton to confirm or lock it now.
      </span>
      <button class="btn btn-sm btn-success ms-2" (click)="preAlertLocked = true">
        <i class="fas fa-lock me-1"></i>Lock
      </button>
    </div>
  </div>

  <!-- Alert Messages -->
  <div [class]="alertClass" *ngIf="showAlert" [@fadeIn]>
    <div class="d-flex align-items-center">
      <i class="fas me-2"
         [class.fa-check-circle]="alertType === 'success'"
         [class.fa-exclamation-triangle]="alertType === 'warning'"
         [class.fa-times-circle]="alertType === 'error'"></i>
      <span>{{alertMessage}}</span>
      <button type="button"
              class="btn-close ms-auto"
              (click)="showAlert = false">
      </button>
    </div>
  </div>

  <!-- Scanner Controls -->
  <div class="modern-card">
    <div>
      <!-- Primary Action Buttons -->
      <div class="row mb-3">
        <div class="col-6">
          <button type="button"
                  class="btn-scanner-primary w-100"
                  [class.danger]="cameraScannerActive"
                  [disabled]="disabled || !canUseCamera"
                  (click)="toggleCameraScanner()">
            <i class="fas fa-lg"
               [class.fa-camera]="!cameraScannerActive"
               [class.fa-stop]="cameraScannerActive"></i>
            <small>{{cameraScannerActive ? 'Stop' : 'Start Scanner'}}</small>
          </button>
        </div>
        <div class="col-6">
          <button type="button"
                  class="btn-scanner-primary success w-100"
                  [disabled]="disabled"
                  (click)="toggleManualEntry()">
            <i class="fas fa-keyboard fa-lg"></i>
            <small>Manual</small>
          </button>
        </div>
      </div>

      <!-- Manual Entry Form -->
      <div class="mb-3" *ngIf="manualEntry">
        <div class="input-group mb-2">
          <input type="text"
                 class="form-control form-control-lg"
                 id="manualCartonInput"
                 placeholder="Enter carton number"
                 [(ngModel)]="manualCartonNo"
                 [disabled]="disabled"
                 (keyup.enter)="addManualEntry()">
        </div>
        <button class="btn-scanner-primary"
                type="button"
                [disabled]="disabled || !manualCartonNo.trim()"
                (click)="addManualEntry()">
          <i class="fas fa-plus fs-4"></i>
          Submit Scan
        </button>
      </div>

      <!-- Validation Controls -->
      <div class="form-check form-switch mb-3" *ngIf="autoDetectedPreAlert">
        <input class="form-check-input" type="checkbox"
               [(ngModel)]="validateCartonsAgainstPreAlert"
               id="validateSwitch">
        <label class="form-check-label" for="validateSwitch">
          <i class="fas fa-shield-alt me-1"></i>
          Validate scans against pre-alert cartons
        </label>
      </div>

      <!-- Utility Buttons -->
      <div class="row g-2">
        <div class="col-4">
          <button type="button"
                  class="btn-scanner-secondary w-100"
                  [disabled]="scannedCartons.length === 0"
                  (click)="clearAll()">
            <i class="fas fa-trash"></i>
            Clear
          </button>
        </div>
        <div class="col-4">
          <button type="button"
                  class="btn-scanner-primary success w-100"
                  [disabled]="scannedCartons.length === 0"
                  (click)="completeScan()">
            <i class="fas fa-check"></i>
            Complete
          </button>
        </div>
        <div class="col-4">
          <button type="button"
                  class="btn-scanner-secondary w-100 scan-counter-button"
                  disabled
                  [class.text-warning]="scanCountStatus.color === 'warning'"
                  [class.text-success]="scanCountStatus.color === 'success'"
                  [title]="offlineScans.length > 0 ? offlineScans.length + ' scans pending sync' : 'Total cartons scanned'">
            <div class="d-flex flex-column align-items-center w-100">
              <i class="fas" [ngClass]="scanCountStatus.icon"></i>
              <strong>{{scanCountStatus.count}}</strong>
              <small>{{scanCountStatus.label}}</small>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>


  <!-- === QUAGGA2 BARCODE SCANNER === -->
  <div class="card mb-3" *ngIf="cameraScannerActive">
    <div class="card-header d-flex justify-content-between align-items-center bg-success text-white">
      <h6 class="mb-0">
        <i class="bi bi-upc-scan me-2"></i>
        Quagga2 Scanner (Enhanced)
      </h6>
      <div class="scanner-mode-badge-header">
        <span class="badge bg-light text-success">
          <i class="bi bi-lightning-charge-fill me-1"></i>
          Fast Mode
        </span>
      </div>
    </div>
    <div class="card-body p-0 position-relative">
      <!-- Quagga2 Scanner Container -->
      <div #quaggaScanner id="quagga-scanner" class="quagga-scanner-view">
        <!-- Quagga2 will inject video and canvas here -->
      </div>

      <!-- OCR Progress Indicator (NEW) -->
      <div class="ocr-progress-overlay" *ngIf="ocrProcessing">
        <div class="ocr-progress-content">
          <div class="spinner-border text-info mb-3" role="status">
            <span class="visually-hidden">Processing...</span>
          </div>
          <div class="ocr-status-text">{{ scanningStatus }}</div>
          <div class="progress mt-3" style="height: 12px; width: 200px;">
            <div class="progress-bar progress-bar-striped progress-bar-animated bg-info"
                 [style.width.%]="ocrProgress"
                 role="progressbar">
              {{ ocrProgress }}%
            </div>
          </div>
        </div>
      </div>

      <!-- Scanner Mode Indicator -->
      <div class="scanner-mode-indicator" *ngIf="scannerMode">
        <span class="badge"
              [class.bg-success]="scannerMode.mode === 'quagga'"
              [class.bg-info]="scannerMode.mode === 'ocr'"
              [class.bg-secondary]="scannerMode.mode === 'manual'">
          <i class="bi bi-upc-scan me-1" *ngIf="scannerMode.mode === 'quagga'"></i>
          <i class="bi bi-fonts me-1" *ngIf="scannerMode.mode === 'ocr'"></i>
          <i class="bi bi-keyboard me-1" *ngIf="scannerMode.mode === 'manual'"></i>
          {{ scannerMode.mode === 'quagga' ? 'Quagga2' :
             (scannerMode.mode === 'ocr' ? 'OCR' : 'Manual') }}
        </span>
      </div>

      <!-- Scanner Controls Overlay -->
      <div class="scanner-controls-overlay">
        <!-- Camera Switch Button (Back/Front) -->
        <button type="button"
                class="btn btn-light btn-sm rounded-circle me-2"
                (click)="switchCamera()"
                [disabled]="availableDevices.length <= 1"
                title="Switch Camera ({{ availableDevices.length > 1 ? 'Front/Back' : 'Only 1 camera' }})">
          <i class="bi bi-camera-video-fill"></i>
        </button>

        <!-- Stop Scanner Button -->
        <button type="button"
                class="btn btn-light btn-sm rounded-circle"
                (click)="stopCameraScanner()"
                title="Stop Scanner">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
    </div>
    <div class="card-footer bg-light">
      <small class="text-muted">
        <i class="bi bi-info-circle me-1"></i>
        Position barcode in frame. OCR fallback available if barcode fails.
      </small>
    </div>
  </div>

  <!-- === NEW: OCR CONFIRMATION DIALOG === -->
  <div class="ocr-confirm-modal" *ngIf="showOcrConfirmDialog" [@fadeIn]>
    <div class="modal-backdrop" (click)="retryOcr()"></div>
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content shadow-lg">
        <div class="modal-header bg-gradient-primary">
          <h5 class="modal-title text-white">
            <i class="bi bi-fonts me-2"></i>
            Text Detected via OCR
          </h5>
        </div>

        <div class="modal-body text-center p-4">
          <!-- Detected Text Display -->
          <div class="detected-text-display mb-3">
            {{ currentOcrResult?.text }}
          </div>

          <!-- Confidence Badge -->
          <div class="confidence-badge mb-3">
            <span class="badge fs-6"
                  [class.bg-success]="(currentOcrResult?.confidence || 0) >= 90"
                  [class.bg-warning]="(currentOcrResult?.confidence || 0) >= 70 && (currentOcrResult?.confidence || 0) < 90"
                  [class.bg-danger]="(currentOcrResult?.confidence || 0) < 70">
              <i class="bi bi-graph-up me-1"></i>
              Confidence: {{ (currentOcrResult?.confidence || 0).toFixed(0) }}%
            </span>
          </div>

          <!-- Instructions -->
          <p class="text-muted mb-0">
            <small>
              <i class="bi bi-info-circle me-1"></i>
              Please confirm if this is the correct carton number
            </small>
          </p>
        </div>

        <div class="modal-footer d-flex gap-2 p-3">
          <button (click)="confirmOcrUse()"
                  class="btn btn-success btn-lg flex-fill">
            <i class="bi bi-check-circle me-2"></i>
            Use This
          </button>
          <button (click)="retryOcr()"
                  class="btn btn-secondary">
            <i class="bi bi-arrow-repeat me-2"></i>
            Retry
          </button>
          <button (click)="switchToManualEntry()"
                  class="btn btn-outline-secondary">
            <i class="bi bi-keyboard me-2"></i>
            Manual
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Scanned Cartons History -->
  <div class="card" *ngIf="showHistory && scannedCartons.length > 0">
    <div class="card-header">
      <h6 class="mb-0">
        <i class="fas fa-history me-2"></i>
        Scanned Cartons ({{scannedCartons.length}})
      </h6>
    </div>
    <div class="card-body p-2">
      <div class="list-group list-group-flush">
        <div class="list-group-item d-flex justify-content-between align-items-center py-2 px-3"
             *ngFor="let item of scannedCartons; trackBy: trackByCartonNo">
          
          <!-- Carton Info -->
          <div class="flex-grow-1">
            <div class="d-flex align-items-center">
              <i class="fas me-2"
                 [class.fa-check-circle]="item.status === 'matched'"
                 [class.fa-exclamation-circle]="item.status === 'unexpected'"
                 [class.text-success]="item.status === 'matched'"
                 [class.text-warning]="item.status === 'unexpected'"></i>
              <strong class="me-2">
                {{item.cartonNo}}
                <span *ngIf="autoDetectedPreAlert"> - Pre-Alert {{autoDetectedPreAlert.ladingBill}}</span>
              </strong>
              <span class="badge"
                    [class.bg-success]="item.isExpected"
                    [class.bg-warning]="!item.isExpected">
                {{item.isExpected ? 'Expected' : 'Extra'}}
              </span>
            </div>
            <small class="text-muted">
              <i class="fas fa-clock me-1"></i>
              {{formatTimestamp(item.scannedAt)}}
            </small>
          </div>

          <!-- Remove Button -->
          <button type="button"
                  class="btn btn-outline-danger btn-sm"
                  [disabled]="disabled"
                  (click)="removeScannedCarton(item.cartonNo)"
                  title="Remove scanned carton"
                  aria-label="Remove scanned carton">
            <i class="bi bi-trash"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Carton List Panel -->
  <div class="card mb-3" *ngIf="hasCartonList && showCartonListPanel">
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col">
          <h6 class="mb-0">
            <i class="fas fa-list-check me-2"></i>
            {{cartonListTitle}}
          </h6>
        </div>
        <div class="col-auto">
          <div class="btn-group btn-group-sm">
            <!-- Refresh Button -->
            <button type="button"
                    class="btn btn-outline-primary"
                    [disabled]="cartonListLoading"
                    (click)="refreshCartonList()"
                    title="Refresh pre-alert carton list"
                    aria-label="Refresh pre-alert carton list">
              <i class="bi bi-arrow-clockwise"></i>
            </button>

            <!-- Toggle Collapse -->
            <button type="button"
                    class="btn btn-outline-secondary"
                    (click)="toggleCartonListCollapsed()"
                    [title]="cartonListPanelCollapsed ? 'Expand list' : 'Collapse list'"
                    [attr.aria-label]="cartonListPanelCollapsed ? 'Expand carton list' : 'Collapse carton list'">
              <i class="bi"
                 [class.bi-chevron-up]="!cartonListPanelCollapsed"
                 [class.bi-chevron-down]="cartonListPanelCollapsed"></i>
            </button>

            <!-- Close Panel -->
            <button type="button"
                    class="btn btn-outline-danger"
                    (click)="toggleCartonListPanel()"
                    title="Close pre-alert panel"
                    aria-label="Close pre-alert panel">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Progress Overview -->
    <div class="card-body p-3" *ngIf="!cartonListPanelCollapsed">
      <!-- Progress Bar -->
      <div class="mb-3">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <span class="text-muted small">Scanning Progress</span>
          <span class="badge bg-info">{{scannedCartonsCount}}/{{totalCartonsCount}} cartons</span>
        </div>
        <div class="progress mb-2" style="height: 8px;">
          <div class="progress-bar"
               [class]="cartonListProgressClass"
               [style.width.%]="cartonListProgress"
               role="progressbar">
          </div>
        </div>
        <div class="text-center">
          <span class="h5 mb-0">{{cartonListProgress}}%</span>
          <span class="text-muted ms-2">Complete</span>
        </div>
      </div>

      <!-- Summary Stats -->
      <div class="row text-center mb-3">
        <div class="col-4">
          <div class="h5 mb-1 text-success">{{scannedCartonsCount}}</div>
          <small class="text-muted">Scanned</small>
        </div>
        <div class="col-4">
          <div class="h5 mb-1 text-warning">{{unscannedCartonsCount}}</div>
          <small class="text-muted">Remaining</small>
        </div>
        <div class="col-4">
          <div class="h5 mb-1 text-primary">{{totalCartonsCount}}</div>
          <small class="text-muted">Total</small>
        </div>
      </div>

      <!-- Search Bar -->
      <div class="input-group mb-3">
        <input type="text"
               class="form-control"
               placeholder="Search carton numbers..."
               [(ngModel)]="cartonSearchTerm"
               (input)="onCartonSearchChange()">
        <button class="btn btn-outline-secondary"
                type="button"
                *ngIf="cartonSearchTerm"
                (click)="clearCartonSearch()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <!-- Filter Tabs with Copy Buttons -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <ul class="nav nav-tabs nav-tabs-sm flex-grow-1">
          <li class="nav-item">
            <button class="nav-link"
                    [class.active]="activeCartonListTab === 'all'"
                    (click)="setActiveCartonListTab('all')">
              All ({{totalCartonsCount}})
            </button>
          </li>
          <li class="nav-item">
            <button class="nav-link"
                    [class.active]="activeCartonListTab === 'scanned'"
                    (click)="setActiveCartonListTab('scanned')">
              <i class="fas fa-check-circle text-success me-1"></i>
              Scanned ({{scannedCartonsCount}})
            </button>
          </li>
          <li class="nav-item">
            <button class="nav-link"
                    [class.active]="activeCartonListTab === 'unscanned'"
                    (click)="setActiveCartonListTab('unscanned')">
              <i class="fas fa-circle text-muted me-1"></i>
              Remaining ({{unscannedCartonsCount}})
            </button>
          </li>
        </ul>

        <!-- Copy Button for Active Tab -->
        <div class="ms-2">
          <button *ngIf="activeCartonListTab === 'all' && totalCartonsCount > 0"
                  class="btn btn-sm btn-outline-secondary"
                  (click)="copyToClipboard('all')"
                  title="Copy all cartons to clipboard">
            <i class="bi bi-clipboard"></i> Copy All
          </button>
          <button *ngIf="activeCartonListTab === 'scanned' && scannedCartonsCount > 0"
                  class="btn btn-sm btn-outline-success"
                  (click)="copyToClipboard('scanned')"
                  title="Copy scanned cartons to clipboard">
            <i class="bi bi-clipboard-check"></i> Copy Scanned
          </button>
          <button *ngIf="activeCartonListTab === 'unscanned' && unscannedCartonsCount > 0"
                  class="btn btn-sm btn-outline-warning"
                  (click)="copyToClipboard('remaining')"
                  title="Copy remaining cartons to clipboard">
            <i class="bi bi-clipboard-minus"></i> Copy Remaining
          </button>
        </div>
      </div>

      <!-- Carton List -->
      <div class="carton-list-container" style="max-height: 400px; overflow-y: auto;">
        <!-- Loading State -->
        <div class="text-center py-4" *ngIf="cartonListLoading">
          <div class="spinner-border spinner-border-sm text-primary me-2"></div>
          Loading carton list...
        </div>

        <!-- Error State -->
        <div class="alert alert-danger py-2" *ngIf="cartonListError">
          <i class="fas fa-exclamation-triangle me-2"></i>
          {{cartonListError}}
          <button type="button"
                  class="btn btn-sm btn-outline-danger ms-2"
                  (click)="refreshCartonList()">
            Retry
          </button>
        </div>

        <!-- Carton Items -->
        <div class="list-group list-group-flush" *ngIf="!cartonListLoading && !cartonListError">
          <div class="list-group-item d-flex justify-content-between align-items-center py-2 px-3"
               *ngFor="let carton of searchResults; trackBy: trackByCartonNumber"
               (click)="onCartonItemClick(carton)"
               [class.list-group-item-success]="carton.isScanned"
               [class.list-group-item-light]="!carton.isScanned"
               style="cursor: pointer;">

            <!-- Carton Info -->
            <div class="flex-grow-1">
              <div class="d-flex align-items-center">
                <!-- Status Icon -->
                <i class="fas me-3"
                   [class.fa-check-circle]="carton.isScanned"
                   [class.fa-circle]="!carton.isScanned"
                   [class.text-success]="carton.isScanned"
                   [class.text-muted]="!carton.isScanned"></i>

                <!-- Carton Number -->
                <div>
                  <div class="fw-bold">{{carton.cartonNumber}}</div>
                  <small class="text-muted" *ngIf="carton.isScanned && carton.scannedAt">
                    <i class="fas fa-clock me-1"></i>
                    Scanned {{formatTimestamp(carton.scannedAt)}}
                    <span *ngIf="carton.scannedBy"> by {{carton.scannedBy}}</span>
                  </small>
                  <small class="text-muted" *ngIf="!carton.isScanned">
                    Pending scan
                  </small>
                </div>
              </div>
            </div>

            <!-- Status Badge -->
            <div class="text-end">
              <span class="badge"
                    [class.bg-success]="carton.isScanned"
                    [class.bg-warning]="!carton.isScanned"
                    [class.bg-danger]="carton.status === 'unexpected'">
                <i class="fas"
                   [class.fa-check]="carton.isScanned"
                   [class.fa-clock]="!carton.isScanned && carton.status === 'pending'"
                   [class.fa-exclamation-triangle]="carton.status === 'unexpected'"></i>
                {{carton.isScanned ? 'Scanned' : 'Pending'}}
              </span>
            </div>
          </div>

          <!-- No Results -->
          <div class="text-center py-4 text-muted" *ngIf="searchResults.length === 0">
            <i class="fas fa-search fa-2x mb-2"></i>
            <p class="mb-0">No cartons found</p>
            <small *ngIf="cartonSearchTerm">Try adjusting your search term</small>
          </div>
        </div>
      </div>

      <!-- Quick Actions -->
      <div class="row mt-3" *ngIf="unscannedCartonsCount > 0">
        <div class="col-6">
          <button type="button"
                  class="btn btn-outline-primary w-100 btn-sm"
                  (click)="setActiveCartonListTab('unscanned')">
            <i class="fas fa-list me-1"></i>
            View Remaining
          </button>
        </div>
        <div class="col-6">
          <button type="button"
                  class="btn btn-outline-success w-100 btn-sm"
                  [disabled]="!cameraScannerActive"
                  (click)="toggleCameraScanner()">
            <i class="fas fa-barcode me-1"></i>
            Start Scanning
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Carton List Toggle Button (when panel is hidden) -->
  <div class="d-grid gap-2 mb-3" *ngIf="hasCartonList && !showCartonListPanel">
    <button type="button"
            class="btn btn-outline-info"
            (click)="toggleCartonListPanel()">
      <i class="fas fa-list-check me-2"></i>
      Show Carton List ({{scannedCartonsCount}}/{{totalCartonsCount}})
      <span class="badge bg-info ms-2">{{cartonListProgress}}%</span>
    </button>
  </div>

  <!-- Empty State -->
  <div class="text-center text-muted py-5"
       *ngIf="scannedCartons.length === 0 && !cameraScannerActive">
    <i class="fas fa-boxes fa-3x mb-3"></i>
    <p>No cartons scanned yet.</p>
    <p class="small">Start scanning or enter cartons manually.</p>

    <!-- Camera Status Info -->
    <div class="mt-3" *ngIf="!cameraEnabled">
      <div class="alert alert-warning py-2">
        <small>
          <i class="fas fa-camera-slash me-1"></i>
          Camera not available. Use barcode scanner or manual entry.
        </small>
      </div>
    </div>

    <div class="mt-3" *ngIf="cameraEnabled && !hasDevicePermission">
      <div class="alert alert-info py-2">
        <small>
          <i class="fas fa-info-circle me-1"></i>
          Camera permission required for camera scanning.
        </small>
      </div>
    </div>
  </div>

  <!-- PHASE 4: COMPLETION MODAL -->
  <div class="modal fade" [class.show]="showCompletionModal" [style.display]="showCompletionModal ? 'block' : 'none'" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-0 shadow-lg" [@scaleIn]>
        <div class="modal-header bg-success text-white border-0">
          <h5 class="modal-title">
            <i class="bi bi-check-circle-fill me-2"></i>
            Scanning Complete!
          </h5>
          <button type="button" class="btn-close btn-close-white" (click)="showCompletionModal = false"></button>
        </div>
        <div class="modal-body text-center p-4">
          <div class="completion-animation mb-3">
            <i class="bi bi-box-seam-fill text-success" style="font-size: 72px;"></i>
          </div>
          <h4 class="fw-bold mb-3">All Cartons Scanned!</h4>
          <p class="text-muted mb-3" *ngIf="scanProgressRT">
            Successfully scanned <strong>{{ scanProgressRT.totalCartons }}</strong> cartons for pre-alert
            <br>
            <span class="badge bg-primary mt-2">{{ scanProgressRT.ladingBill }}</span>
          </p>
          <div class="d-flex justify-content-center gap-3 mt-4">
            <button class="btn-scanner-primary success" style="width: auto;" (click)="viewScanSummary()">
              <i class="bi bi-list-check"></i>
              View Summary
            </button>
            <button class="btn-scanner-secondary" (click)="startNewScan()">
              <i class="bi bi-arrow-clockwise"></i>
              New Scan
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade" [class.show]="showCompletionModal" *ngIf="showCompletionModal"></div>

  <!-- PHASE 1: COLLAPSIBLE CONFIG PANEL -->
  <div class="collapsible-panel" *ngIf="autoDetectedPreAlert">
    <button class="panel-toggle-btn" (click)="toggleConfigPanel()">
      <span>
        <i class="bi bi-gear me-2"></i>
        Configuration
      </span>
      <i class="bi" [class.bi-chevron-down]="!showConfigPanel" [class.bi-chevron-up]="showConfigPanel"></i>
    </button>
    <div class="panel-content" *ngIf="showConfigPanel">
      <div class="form-check form-switch mb-2">
        <input class="form-check-input" type="checkbox"
               [(ngModel)]="validateCartonsAgainstPreAlert"
               id="validateSwitch">
        <label class="form-check-label" for="validateSwitch">
          <i class="bi bi-shield-check me-1"></i>
          Validate against pre-alert
        </label>
      </div>
    </div>
  </div>

  <!-- PHASE 4: COLLAPSIBLE SETTINGS PANEL -->
  <div class="collapsible-panel">
    <button class="panel-toggle-btn" (click)="toggleSettings()">
      <span>
        <i class="bi bi-gear me-2"></i>
        Scanner Settings
      </span>
      <i class="bi" [class.bi-chevron-down]="!showSettings" [class.bi-chevron-up]="showSettings"></i>
    </button>
    <div class="panel-content" *ngIf="showSettings">
      <div class="form-check form-switch mb-3">
        <input class="form-check-input" type="checkbox" id="soundToggle"
               [checked]="soundEnabled" (change)="toggleSound()">
        <label class="form-check-label" for="soundToggle">
          <i class="bi bi-volume-up me-2"></i>Sound Effects
        </label>
      </div>
      <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" id="hapticToggle"
               [checked]="hapticEnabled" (change)="toggleHaptic()">
        <label class="form-check-label" for="hapticToggle">
          <i class="bi bi-phone-vibrate me-2"></i>Haptic Feedback
        </label>
      </div>
    </div>
  </div>

  <!-- PHASE 1: FLOATING ACTION BUTTON (FAB) -->
  <button class="fab-button"
          [class.fab-ready]="!cameraScannerActive"
          [class.fab-scanning]="cameraScannerActive"
          [disabled]="disabled"
          (click)="toggleFAB()">
    <i class="bi"
       [class.bi-camera-fill]="!cameraScannerActive"
       [class.bi-stop-fill]="cameraScannerActive"></i>
  </button>

  <!-- PHASE 5: DUPLICATE SCAN WARNING MODAL -->
  <div class="modal fade" [class.show]="showDuplicateWarning" [style.display]="showDuplicateWarning ? 'block' : 'none'" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-0 shadow-lg" *ngIf="duplicateScanInfo" [@scaleIn]>
        <!-- Header - Warning Style -->
        <div class="modal-header bg-warning text-dark border-0">
          <h5 class="modal-title fw-bold">
            <i class="bi bi-exclamation-triangle-fill me-2"></i>
            Duplicate Scan Detected
          </h5>
          <button type="button" class="btn-close" (click)="closeDuplicateWarning()"></button>
        </div>

        <!-- Body - Duplicate Info -->
        <div class="modal-body p-4">
          <!-- Carton Info -->
          <div class="alert alert-warning border-warning d-flex align-items-center">
            <i class="bi bi-box-seam-fill fs-3 me-3"></i>
            <div>
              <div class="fw-bold">{{ duplicateScanInfo.cartonNumber }}</div>
              <small class="text-muted" *ngIf="duplicateScanInfo.ladingBill">{{ duplicateScanInfo.ladingBill }}</small>
            </div>
          </div>

          <!-- Previous Scan Details -->
          <h6 class="fw-bold mt-3 mb-3">
            <i class="bi bi-clock-history me-2"></i>
            Previous Scan Information
          </h6>

          <div class="previous-scan-card">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="text-muted">Scanned by:</span>
              <strong>{{ duplicateScanInfo.previousScan.scannedBy }}</strong>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="text-muted">Date & Time:</span>
              <strong>{{ duplicateScanInfo.previousScan.scannedAtFormatted || (duplicateScanInfo.previousScan.scannedAt | date:'short') }}</strong>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <span class="text-muted">Time elapsed:</span>
              <span class="badge bg-secondary">
                {{ duplicateScanInfo.previousScan.minutesAgo }} minutes ago
              </span>
            </div>
          </div>

          <!-- Same User Warning -->
          <div class="alert alert-info mt-3 mb-0" *ngIf="duplicateScanInfo.previousScan.isSameUser">
            <i class="bi bi-info-circle me-2"></i>
            <strong>Note:</strong> You already scanned this carton.
          </div>

          <!-- View Scan History Button -->
          <div class="mt-3 text-center">
            <button class="btn btn-outline-secondary btn-sm"
                    (click)="viewScanHistory(duplicateScanInfo.cartonNumber)"
                    [disabled]="loadingScanHistory">
              <i class="bi bi-list-ul me-2"></i>
              {{ loadingScanHistory ? 'Loading...' : 'View Complete Scan History' }}
            </button>
          </div>

          <!-- Scan History Display -->
          <div class="scan-history-section mt-3" *ngIf="scanHistory">
            <div class="card border-secondary">
              <div class="card-header bg-light">
                <h6 class="mb-0">
                  <i class="bi bi-journal-text me-2"></i>
                  Scan History ({{ scanHistory.totalScans }} attempts)
                </h6>
              </div>
              <div class="card-body p-0">
                <div class="list-group list-group-flush">
                  <div *ngFor="let attempt of scanHistory.scanAttempts"
                       class="list-group-item d-flex justify-content-between align-items-center">
                    <div>
                      <i class="bi me-2"
                         [class.bi-check-circle-fill]="attempt.action === 'SUCCESS'"
                         [class.text-success]="attempt.action === 'SUCCESS'"
                         [class.bi-x-circle-fill]="attempt.action === 'DUPLICATE_REJECTED'"
                         [class.text-danger]="attempt.action === 'DUPLICATE_REJECTED'"
                         [class.bi-arrow-counterclockwise]="attempt.action === 'DUPLICATE_OVERRIDDEN'"
                         [class.text-warning]="attempt.action === 'DUPLICATE_OVERRIDDEN'"></i>
                      <strong>{{ attempt.scannedBy }}</strong>
                      <br>
                      <small class="text-muted">{{ attempt.scanAtUtc | date:'short' }}</small>
                    </div>
                    <span class="badge"
                          [class.bg-success]="attempt.action === 'SUCCESS'"
                          [class.bg-danger]="attempt.action === 'DUPLICATE_REJECTED'"
                          [class.bg-warning]="attempt.action === 'DUPLICATE_OVERRIDDEN'">
                      {{ attempt.action }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer - Actions -->
        <div class="modal-footer border-0 bg-light">
          <button class="btn-scanner-secondary" (click)="closeDuplicateWarning()">
            <i class="bi bi-x-lg"></i>
            Close
          </button>

          <!-- Admin Override Button (only show for admins) -->
          <button class="btn-scanner-primary warning"
                  style="width: auto;"
                  *ngIf="isAdminUser"
                  (click)="adminOverrideScan()">
            <i class="bi bi-shield-exclamation"></i>
            Admin: Reset Scan
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade" [class.show]="showDuplicateWarning" *ngIf="showDuplicateWarning"></div>

  <!-- Bulk Update Results Modal -->
  <div class="modal fade" [class.show]="showBulkUpdateResults" [style.display]="showBulkUpdateResults ? 'block' : 'none'" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header" [class.bg-success]="bulkUpdateResults?.allSuccessful" [class.bg-warning]="!bulkUpdateResults?.allSuccessful">
          <h5 class="modal-title text-white">
            <i class="bi" [class.bi-check-circle]="bulkUpdateResults?.allSuccessful" [class.bi-exclamation-triangle]="!bulkUpdateResults?.allSuccessful"></i>
            Bulk Update Results
          </h5>
          <button type="button" class="btn-close btn-close-white" (click)="closeBulkUpdateResults()"></button>
        </div>
        <div class="modal-body" *ngIf="bulkUpdateResults">
          <div class="alert alert-info mb-3">
            <strong>Summary:</strong> {{bulkUpdateResults.message}}
          </div>

          <div class="row text-center mb-3">
            <div class="col-4">
              <div class="card bg-light">
                <div class="card-body py-2">
                  <h6 class="mb-1">✅ Success</h6>
                  <h4 class="text-success mb-0">{{bulkUpdateResults.successfulUpdates}}</h4>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="card bg-light">
                <div class="card-body py-2">
                  <h6 class="mb-1">⏭️ Skipped</h6>
                  <h4 class="text-info mb-0">{{bulkUpdateResults.skippedAlreadyScanned}}</h4>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="card bg-light">
                <div class="card-body py-2">
                  <h6 class="mb-1">❌ Failed</h6>
                  <h4 class="text-danger mb-0">{{bulkUpdateResults.failedUpdates}}</h4>
                </div>
              </div>
            </div>
          </div>

          <!-- Failed Cartons Details -->
          <div *ngIf="bulkUpdateResults.failedCartons && bulkUpdateResults.failedCartons.length > 0" class="alert alert-danger">
            <h6 class="alert-heading">Failed Cartons:</h6>
            <ul class="mb-0">
              <li *ngFor="let failed of bulkUpdateResults.failedCartons">
                <strong>{{failed.cartonNumber}}</strong>: {{failed.errorMessage}}
                <small class="text-muted">(Retry: {{failed.retryCount}})</small>
              </li>
            </ul>
          </div>

          <!-- Retry Instructions -->
          <div *ngIf="!bulkUpdateResults.allSuccessful" class="alert alert-warning">
            <i class="bi bi-info-circle me-2"></i>
            <strong>Session kept open.</strong> Press the Complete button again to retry failed cartons.
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeBulkUpdateResults()">
            Close
          </button>
          <button *ngIf="!bulkUpdateResults?.allSuccessful" type="button" class="btn btn-primary" (click)="closeBulkUpdateResults(); completeWithBulkUpdate()">
            <i class="bi bi-arrow-repeat"></i> Retry Now
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade" [class.show]="showBulkUpdateResults" *ngIf="showBulkUpdateResults"></div>
</div>